// TODO: consider bringing in viz-core and importing.
// Copy paste in this patch for now because we'd need to evaluate how much more bundle size we'd add.

/**
 * Maps page type to viz type.
 */
export function vizTypeToPageType(vizTypeOrPageType) {
  switch (vizTypeOrPageType) {
    case 'list':
      return 'TABLE';
    case 'board':
      return 'BOARD';
    case 'gantt':
      return 'GANTT_CHART';
    case 'report':
      return 'REPORTING';
    case 'map':
      return 'MAP';
    case 'datawell':
      return 'DATA_WELL';
    case 'calendar':
      return 'CALENDAR';
    default:
      return vizTypeOrPageType.toUpperCase();
  }
}

/**
 * Maps viz type to page type.
 */
export function pageTypeToVizType(vizTypeOrPageType) {
  switch (vizTypeOrPageType) {
    case 'TABLE':
      return 'list';
    case 'BOARD':
      return 'board';
    case 'GANTT_CHART':
      return 'gantt';
    case 'REPORTING':
      return 'report';
    case 'MAP':
      return 'map';
    case 'DATA_WELL':
      return 'datawell';
    case 'CALENDAR':
      return 'calendar';
    default:
      return vizTypeOrPageType;
  }
}